import { useState } from "react";
import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";

import useSAAGroupMembersData from "../../../state/scholasticAllAmericaGroup/scholasticAllAmericaGroupMembers/UseSAAGroupMembersData";
import useSAAGroupData from "../../../state/scholasticAllAmericaGroup/UseSAAGroupData";

import useNavRoutes from "@usas/ui-web/state/security/UseNavRoutes";

const INITIAL_STATE = {
  displayWorkflowPopup: false,
  workflowMemberObj: {}
};

const useSAAGroupMembers = () => {
  const navigate = useNavigate();
  const { onSAAGroupsError } = useSAAGroupData();
  const { navRoutes } = useNavRoutes();
  const { groupMembersState, getSAAGroupMembers } = useSAAGroupMembersData();
  const [state, setState] = useState(INITIAL_STATE);

  const onEditGroupMemberClicked = (event, member) => {
    try {
      event?.preventDefault();

      navigate(navRoutes.SAA_GROUP_MEMBERS_DETAIL?.route, { state: { member } });
    } catch (e) {
      onSAAGroupsError(e);
    }
  };

  const onEditGroupMemberStatusClicked = (event, member) => {
    try {
      event?.preventDefault();

      setState({
        ...state,
        displayWorkflowPopup: true,
        workflowMemberObj: member
      });
    } catch (e) {
      onSAAGroupsError(e);
    }
  };

  const onCloseWorkflowPopup = (event, refreshGrid = false) => {
    try {
      event?.preventDefault();

      if (refreshGrid === true) {
        getSAAGroupMembers(groupMembersState.orgGroupId);
      }

      setState({
        ...state,
        displayWorkflowPopup: false,
        workflowMemberObj: {}
      });
    } catch (e) {
      onSAAGroupsError(e);
    }
  };

  return {
    isGridLoading: groupMembersState.isObjLoading,
    gridData: groupMembersState.arrayData || [],
    state,
    onEditGroupMemberClicked,
    onEditGroupMemberStatusClicked,
    onCloseWorkflowPopup
  };
};

export default useSAAGroupMembers;